import '../scss/App.scoped.scss';
import { useRef} from 'react';
import { SecDep } from './dep/SecDep';
import Pselect from '../pfields/Pselect';
import Ptext from '../pfields/Ptext';
import Ptextarea from '../pfields/Ptextarea';
import PcheckboxGroup from '../pfields/PcheckboxGroup';
import Pcaptcha from '../pfields/Pcaptcha';
import Delayed from './Delayed';
import { PrimaryDependency } from './dep/PrimaryDependency';

function FormIncomplete({pfields, btnText}) {
  const selectRefs = useRef([]);
  const submit = (e) => {
    e.preventDefault();
    document.querySelector("#p-content form").submit();
  };

  const addSelRefs = (o) => {
    selectRefs.current.push(o);
  }

  const clearSel = (n) => {
    selectRefs.current.filter((sr) => {
      return sr.cname === n;
    }).forEach((srf) => {
      srf.ref.current.setValue(null);
    })
  }

  const dependencyCheck = (e) => {
    PrimaryDependency.check(e).then(
      SecDep.check()
    )
  }
  return (
    <div className="drform">
      <form id="rform" onSubmit={submit}>
        {
          pfields.map((pfield, i) => {
            let robj = (<p key={i}>Unknown field</p>);
            switch(pfield.type) {
              case "select":
                robj =  (<Pselect clearSel={clearSel} addSelRefs={addSelRefs} selRefs={selectRefs} pfield={pfield} key={pfield.id} dcheck={dependencyCheck} isClearable={true}/>);
                break;
              case "text":
                robj = (<Ptext pfield={pfield} key={pfield.id} />);
                break;
              case "textarea":
                robj = (<Ptextarea pfield={pfield} key={pfield.id} />);
                break;
              case "checkbox":
                robj = (<PcheckboxGroup pfield={pfield} key={pfield.id} />);
                break;
              case "captcha":
                robj = (<Delayed waitBeforeShow={2000} key={`d${pfield.id}`}><Pcaptcha pfield={pfield} key={pfield.id}/></Delayed>); 
                break;
              default:
                robj = "";
                break;
            }
            return robj;
          })
        }
        <button type="submit">{btnText}</button>
      </form>
    </div>
  );
}
export default FormIncomplete;